import React from 'react';
import styles from './TestimonialSlide.module.scss';

const TestimonialSlide = props => {
  return (
    <div
      className={styles.slide}
      onTouchStart={(e) => props.handleTouchStart(e)}
      onTouchEnd={(e) => props.handleTouchEnd(e)}
    >
      <img src={props.img} alt={props.name} />
      <div className={styles.textContent}>
        <h2>{props.name}</h2>
        <p>{props.text}</p>
      </div>
    </div>
  );
};

export default TestimonialSlide;
